// Module
var code = "<svg width=\"100%\" height=\"100%\" viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M12 0H0V12H12V0Z\" fill=\"white\" fill-opacity=\"0.01\"/> <path d=\"M1.5 2.25L5.1 6.45444V9.61111L6.9 10.5V6.45444L10.5 2.25H1.5Z\" fill=\"#C1C1C1\" stroke=\"#C1C1C1\" stroke-linejoin=\"round\"/> </svg> ";
// Exports
module.exports = code;